<template>
  <div>
    <van-search v-model="childValue" placeholder="项目搜索" @search="onSearch" />
    <div v-show="List != null" v-cloak>
      <div v-if="List && List.length > 0" style="padding:  15px  20px 60px">

        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div v-for="(item, index) in List" :key="index" class="css-display">
            <div style="text-align: center;font-size: 20px;font-weight: 700;padding: 0 10px;background-color:#ffffff;">
              {{ item.title }}
            </div>

            <div class="p10-size14">
              <div class="title-s">创建时间</div>
              <div class="value-s">{{ item.created_at }}</div>
            </div>
            <div class="p10-size14">
              <div class="title-s">创建人</div>
              <div class="value-s">{{ item.creator_username }}</div>
            </div>
            <div style="padding:10px 10px 0;">
              <button @click="skipDetail(item)" class="buto">踩点信息</button>
              <button @click="delet(item)" class="buto" style="margin-left: 20px;background-color: crimson;">删除</button>
              <button @click="edit(item)" class="buto"
                style="margin-left: 20px;background-color: goldenrod;">修改</button>

            </div>

          </div>

        </van-list>

      </div>
      <div v-show="List.length == 0">
        <van-empty description="暂无信息" />
      </div>
    </div>
    <div class="footers">
      <div class="buttons" @click="addAddr()"> 新建踩点</div>
    </div>

    <van-dialog v-model="addrShow" title="新增踩点" show-cancel-button>
      <div style="padding: 10px;">
        <van-field v-model="addars" label="地址" label-width="50" placeholder="地址" />

      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Dialog, Toast } from 'vant'
export default {
  data () {
    return {
      childValue: '',
      List: [],
      total: 0,
      loading: false,
      finished: false,
      page: 0,
      addrShow: false,
      addars: ''
    }
  },
  created () {
    this.reload()
  },
  methods: {
    reload () {
      this.page = 0
      this.List = []
      this.loading = false
      this.finished = false
      this.getListInfo()
    },
    onLoad () {
      let that = this

      if (this.List.length == this.total) {
        that.loading = false
        that.finished = true
        return
      }
      setTimeout(() => {
        this.getListInfo()
      }, 500)
    },
    getListInfo () {
      let that = this
      that.page++
      this.$axios.get('/caidian/list', {
        params: {
          page: this.page,
          keyword: this.childValue,
        }
      }).then(res => {
        if (res.data.code !== 200) {
          Toast(res.data.msg);
          return
        }

        let data = res.data.data
        for (let i = 0; i < data.length; i++) {
          data[i].title = this.Ellipsis(data[i].title, 10)
          this.List.push(data[i])
        }
        this.total = res.data.total
        // this.List = this.List.contat(data)
        that.loading = false
        if (res.data.data.length == 0) {
          this.listShow = true
          that.finished = true
        }
      })
    },
    onSearch () {
      this.reload()
    },
    Ellipsis (value, length) {
      if (!value) return ''
      // 判断如果不是字符串的话那么就把他转换成字符串截取
      if (typeof value !== String) {
        value = value.toString()

        if (value.length > length) {
          return value.slice(0, length) + '...'
        }
      }

      return value
    },
    // 跳转详情
    skipDetail (item) {
      this.$router.push({
        path: '/footprinting/detail',
        query: {
          id: item.id,
          title: item.title
        },
      })
    },
    addAddr () {
      this.$router.push({
        path: '/footprinting/relevancy',
      })
    },
    edit (item) {
      this.$router.push({
        path: '/footprinting/edit',
        query: {
          title: item.title,
          id: item.id,
          target_id: item.target_id,
          target_title: item.target_title

        }
      })

    },
    delet (item) {
      let that = this
      Dialog.alert({
        title: '是否删除',
        showCancelButton: true
      }).then(res => {


        this.$axios.post('caidian/delete', {
          id: item.id
        }).then(res => {
          if (res.data.code !== 200) {
            Toast(res.data.msg);
            return
          }
          that.reload()

        })
      }).catch(err => {
        console.log(err);
      })

    }
  },
}
</script>
<style lang="scss" scoped>
.css-display {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #f1f1f1;
  padding: 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 4px rgba($color: #4c4d47, $alpha: 0.5);
  margin-bottom: 10px;
}

.buto {
  background-color: royalblue;
  padding: 5px 20px;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
}

.p10-size14 {
  padding: 12px 15px;
  font-size: 14px;
  margin: 0 30px;

  .title-s {
    display: inline-block;
    width: 35%;
    font-weight: 500;
    // color: brown;
    // text-align: center;
  }

  .value-s {
    display: inline-block;
    color: #999;
    width: 65%;
    text-align: right;
  }
}

.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  // justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
  z-index: 1000;

  .buttons {
    background-color: darkseagreen;
    width: 100%;
    padding: 10px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .buttons:active {
    background-color: burlywood;
  }
}
</style>